
export default function authDetails() {
    const obj = JSON.parse(localStorage.getItem("authUser"))
   
      return { email: obj.email.toLowerCase(), customerID: obj.customerID, roleID: obj.roleID, agencyName:obj.agencyName}
    
  }